class CartDrawerBalance extends HTMLElement {
  constructor() {
    super();
    this.label = this.getAttribute('data-label');
    this.generateBalance = this.getAttribute('data-generate-balance');
    this.linkGenerateBalance = this.getAttribute('data-link-generate-balance');
    this.render();
    this.bindEvents();
  }

  formatMoney(value) {
    return value.toFixed(2).replace('.', ',');
  }

  render() {
    const discountBalance = sessionStorage.getItem('discountBalance');
    const cartTotal = this.getCartTotal();

    if (discountBalance) {
      const availableBalance = Math.max(0, parseFloat(discountBalance) - cartTotal);

      this.innerHTML = `
        <p class="cart-drawer__available-balance-label">
          ${this.label}:
        </p>
        <div class="cart-drawer__available-balance-value-container">
          <p class="cart-drawer__available-balance-value">
            R$ ${this.formatMoney(availableBalance)}
          </p>
        </div>
      `;
    } else {
      this.innerHTML = `
        <div class="cart-drawer__no-balance">
          <p class="cart-drawer__no-balance-message">
            <a 
              href="/pages/estimativa-de-saldo" 
              class="cart-drawer__generate-balance-link"
            >
              ${this.linkGenerateBalance}
            </a>
            <span class="cart-drawer__no-balance-message-span">
              ${this.generateBalance}
            </span>
          </p>
        </div>
      `;
      this.classList.add('cart-drawer__available-balance--empty');
    }
  }

  getCartTotal() {
    const cartTotalElement = document.querySelector('.totals__total-value');
    if (!cartTotalElement) return 0;

    const cartTotalText = cartTotalElement.textContent.trim();
    const cartTotal = parseFloat(cartTotalText.replace(/[^0-9,]/g, '').replace(',', '.'));
    return isNaN(cartTotal) ? 0 : cartTotal;
  }

  bindEvents() {
    // Atualiza quando o carrinho é atualizado
    document.addEventListener('cart:updated', () => {
      this.render();
    });

    // Atualiza quando o carrinho é aberto
    document.addEventListener('cart:open', () => {
      this.render();
    });
  }

  updateBalance() {
    this.render();
  }
}

customElements.define('cart-drawer-balance', CartDrawerBalance); 